import { gql } from "@apollo/client";

export const getScheduleTotalCheckCallsByScheduleIdQuery = gql`
query($scheduleId: String!){
  getScheduleTotalCheckCallsByScheduleId(scheduleId: $scheduleId) {
    message
    response
  }
}
`;